import React from 'react';
import ReactDOM from 'react-dom';
import Menu from 'app/blocks/menu/menu';
import StaticSearch from 'app/blocks/static-search/static-search';

// eslint-disable-next-line import/prefer-default-export
export function renderMenu() {
    const menu = document.getElementById('AS__menu');

    return ReactDOM.createPortal(<Menu onDisplay={() => menu.classList.remove('is-loading')} />, menu);
}

export function renderStaticSearch() {
    const staticSearch = document.getElementById('AS__static_search');

    return staticSearch ? ReactDOM.createPortal(<StaticSearch />, staticSearch) : null;
}
